import { Injectable, inject } from '@angular/core';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { GetInvestigationTypesStateResult } from './get-investigation-types-state.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationTypesStateUseCase {
  private readonly _state = inject(InvestigationTypeState);

  public execute(): GetInvestigationTypesStateResult {
    return {
      investigationTypes: this._state.investigationTypes,
      loading: this._state.loading,
      error: this._state.error,
      saving: this._state.saving,
      investigationTypesCount: this._state.investigationTypesCount,
      hasInvestigationTypes: this._state.hasInvestigationTypes,
      categories: this._state.categories,
      loadingChecklist: this._state.loadingChecklist,
      errorChecklist: this._state.errorChecklist,
      savingChecklist: this._state.savingChecklist,
      currentInvestigationType: this._state.currentInvestigationType,
      savingInvestigationTypeStatus: this._state.savingInvestigationTypeStatus,
      isDeletingInvestigationType: this._state.isDeletingInvestigationType,
      investigationTypeDeletionImpact: this._state.investigationTypeDeletionImpact,
      loadingInvestigationTypeDeletionImpact: this._state.loadingInvestigationTypeDeletionImpact,
      errorInvestigationTypeDeletionImpact: this._state.errorInvestigationTypeDeletionImpact,
    };
  }
}
